export const AVAILABLE_PLANT = {
    unavailableReasons: [
        // `Kerry Arts is unavailable from 15/12/2016 8:00am to 15/12/2016 3:00pm`,
        // `Jacob Toye is unavailable from 15/12/2016 11:15am to 15/12/2016 1:30pm`,
    ],
    availablePlantIds: [
        7,
        1,
        3,
        9
    ],
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/availablePlant.js